module.exports = __webpack_public_path__ + "img/inspiration_02@2x.cbf9f93.jpg";